import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { spacing, color, shadow } from '@metro-ui/tokens/js';
import { fontStack } from '../utils/fontStack';
import { responsivePropTypes } from '../utils/responsiveProp';
import { mq } from '../utils/mediaQuery';
import { rgba } from '../utils/rgba';
import { visuallyHidden } from '../utils/visuallyHidden';
import { MaxSizedDiv } from '../utils/MaxSizedDiv';
import { Layout } from '../Layout';
import { Modal } from '../Modal';
import { CookieMessageContext } from './components/CookieMessageContext';
var Title = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), visuallyHidden);
var CookieMessageInner = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.direction, direction = _b === void 0 ? { xs: 'column', m: 'row' } : _b, props = __rest(_a, ["title", "children", "direction"]);
    return (React.createElement(Layout, __assign({ direction: direction, spacing: "large", style: { flexGrow: 1 } }, props),
        title && React.createElement(Title, null, title),
        children));
};
CookieMessageInner.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    // @ts-ignore
    direction: responsivePropTypes(PropTypes.oneOf(['column', 'row'])),
};
export var CookieMessage = styled(function (_a) {
    var title = _a.title, _b = _a.isIntrusive, isIntrusive = _b === void 0 ? false : _b, zIndex = _a.zIndex, _c = _a.maxWidth, maxWidth = _c === void 0 ? 1920 : _c, _d = _a.label, label = _d === void 0 ? 'Cookie message' : _d, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["title", "isIntrusive", "zIndex", "maxWidth", "label", "className", "children"]);
    if (isIntrusive) {
        return (React.createElement(CookieMessageModal, { className: className, isOpen: true, label: label, padding: "large" },
            React.createElement(CookieMessageContext.Provider, { value: { isIntrusive: isIntrusive } },
                React.createElement(CookieMessageInner, { title: title, direction: "column" }, children))));
    }
    return (React.createElement("div", __assign({}, htmlAttributes, { className: className }),
        React.createElement(MaxSizedDiv, { maxWidth: maxWidth, style: { display: 'flex' } },
            React.createElement(CookieMessageInner, { title: title }, children))));
})(function (_a) {
    var _b = _a.zIndex, zIndex = _b === void 0 ? 1 : _b;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: ", ";\n    background: ", ";\n    box-shadow: ", " ", ";\n    z-index: ", ";\n  "], ["\n    ", "\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: ", ";\n    background: ", ";\n    box-shadow: ", " ", ";\n    z-index: ", ";\n  "])), fontStack, spacing.large, color.contrast.white, shadow.inverted.default, rgba(shadow.color, shadow.alpha), zIndex);
});
CookieMessage.propTypes = {
    title: PropTypes.string,
    isIntrusive: PropTypes.bool,
    zIndex: PropTypes.number,
    className: PropTypes.string,
    label: PropTypes.string,
    children: PropTypes.node,
    maxWidth: PropTypes.oneOf([1920, 1440, null]),
};
var CookieMessageModal = styled(function (_a) {
    var label = _a.label, props = __rest(_a, ["label"]);
    return (React.createElement(Modal, __assign({ label: label }, props)));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-width: 303px;\n\n  width: inherit;\n  height: inherit;\n\n  ", " {\n    min-width: 406px;\n    max-width: 406px;\n  }\n"], ["\n  max-width: 303px;\n\n  width: inherit;\n  height: inherit;\n\n  ", " {\n    min-width: 406px;\n    max-width: 406px;\n  }\n"])), mq('m'));
export var CookieMessageContent = styled(function (_a) {
    var className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["className", "children"]);
    return (React.createElement("div", __assign({}, htmlAttributes, { className: className }), children));
})(function () { return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    flex-grow: 1;\n  "], ["\n    color: ", ";\n    flex-grow: 1;\n  "])), color.muted); });
CookieMessageContent.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
var actionClass = 'm-cookieMessage__action';
export var CookieMessageActions = function (props) { return (React.createElement(CookieMessageContext.Consumer, null, function (_a) {
    var isIntrusive = _a.isIntrusive;
    return (React.createElement(CookieMessageActionsInner, __assign({}, props, { isIntrusive: isIntrusive })));
})); };
var CookieMessageActionsInner = styled(function (_a) {
    var className = _a.className, children = _a.children, isIntrusive = _a.isIntrusive, htmlAttributes = __rest(_a, ["className", "children", "isIntrusive"]);
    var direction = isIntrusive
        ? 'column'
        : { xs: 'column', m: 'row' };
    return (React.createElement(Layout, __assign({}, htmlAttributes, { className: className, direction: direction, spacing: "medium", align: "center", basis: "auto", shrink: 0 }), React.Children.map(children, function (child) {
        var element = child;
        return React.isValidElement(element)
            ? React.cloneElement(element, {
                className: element.props.className
                    ? [element.props.className, actionClass].join(' ')
                    : actionClass,
            })
            : element;
    })));
})(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
CookieMessageActions.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=CookieMessage.js.map